import {pageData} from "@/helpers/CypressHelper";

describe('Desktop - product image visibility tests', () => {

    describe('admin user', () => {

        beforeEach(() => {
            cy.useSharedAdminUserSession();

            cy.intercept('POST', 'api/Product/GetRelatedProducts', {fixture: 'product_takeuchi_tb210r_related.json'}).as('data');
        });

        it('Opens ProductDetails and checks if preferred model dropdown not exists', () => {

            cy.intercept('POST', 'api/Product/ProductData', {fixture: 'product_takeuchi_tb210r.json'}).as('data');

            cy.intercept('POST', 'api/Product/GetProductAvailability', {fixture: 'product_takeuchi_tb210r_availability.json'}).as('data');

            cy.visit('tuote/mock-url');

            pageData().rent.product.productImagesContainer().find('img').should('have.length', 9);

            pageData().rent.product.productImagesContainer().find('img[class^="ProductDetails_adminDisabledImage"]').should('exist');
        });
    })

    describe('normal user', () => {

        beforeEach(() => {
            cy.session(['private_user_session'], () => {
                cy.loginAndSelectPrivateRole("juhani.sihvonen@weare.fi");
            });
            cy.intercept('POST', 'api/Product/GetRelatedProducts', {fixture: 'product_takeuchi_tb210r_related.json'}).as('data');
        });

        it('Opens ProductDetails and checks if preferred model dropdown not exists', () => {

            cy.intercept('POST', 'api/Product/ProductData', {fixture: 'product_takeuchi_tb210r.json'}).as('data');

            cy.intercept('POST', 'api/Product/GetProductAvailability', {fixture: 'product_takeuchi_tb210r_availability.json'}).as('data');

            cy.visit('tuote/mock-url');

            pageData().rent.product.productImagesContainer().find('img').should('have.length', 8);
        });
    })


})